export function appendMeasure(parsed, measure) {
  const lines = measure.split(/\r?\n/);
  const matrix = [];
  for (const line of lines) {
    const fields = line.split('|');
    if (fields.length > 0) {
      matrix.push([
        new Date(fields[0].replace('M', '')).getTime(),
        ...fields.slice(1).map(Number),
      ]);
    }
  }
  if (matrix.length > 0) {
    const variables = { t: { label: 'Time', units: 's', data: [] } };
    for (const row of matrix) {
      variables.t.data.push((row[0] - matrix[0][0]) / 1000);
    }
    parsed.variables = variables;
  }
}
